import "../public/buildinfo.json";
import "../styles/main.scss";
import "../styles/card.scss";
import "../styles/util.scss";
import "../styles/button.scss";
import "../styles/dropdown.scss";
import "../styles/tag.scss";
import "../styles/accordion.scss";
import "../styles/tabs.scss";
import "../styles/titletabs.scss";
import "../assets/config/web.config";
import "core-js/stable";
import "regenerator-runtime/runtime";

import {setDeviceType, setInnerHeight, setInnerWidth} from "./kundeweb/actions/view.js";

import {Provider} from "react-redux";
import React from "react";
import ReactDOM from "react-dom";
import RootRouter from "./kundeweb/routes/RootRouter.jsx";
import configureStore from "./common/store/configureStore.js";
import rootReducer from "./kundeweb/reducers/rootReducer.js";

const store = configureStore(rootReducer);

const updateBrowserDimensions = () => {
    const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    const h = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    const action = setDeviceType(w);

    if (store.getState().view.deviceType !== action.deviceType) {
        store.dispatch(action);
    }
    if (store.getState().view.innerHeight !== h) {
        store.dispatch(setInnerHeight(h));
    }
    if (store.getState().view.innerWidth !== w) {
        store.dispatch(setInnerWidth(w));
    }
};

updateBrowserDimensions();

const renderApp = () => {
    ReactDOM.render(
        <Provider store={store}>
            <RootRouter />
        </Provider>,
        document.getElementById("react-main")
    );
};

renderApp();

if (module.hot) {
    module.hot.decline();

    module.hot.accept("./kundeweb/routes/router.jsx", () => {
        renderApp();
    });

    module.hot.accept("./kundeweb/reducers/rootReducer.js", () => {
        store.replaceReducer(rootReducer);
    });
}

addEventListener("resize", updateBrowserDimensions);
document.addEventListener("DOMContentLoaded", updateBrowserDimensions);